import { useMsal } from "@azure/msal-react";
import { ContactIcon } from "@fluentui/react-icons-mdl2";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { logout } from "API/Authorization";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { useLogoutStyles } from "./UseLogoutStyles";

export const Logout = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const { instance, accounts } = useMsal();
  const styles = useLogoutStyles();
  const name = accounts[0] && accounts[0].name;
  const username = accounts[0] && accounts[0].username;

  return (
    <Stack>
      <Stack horizontal>
        <Stack horizontal grow>
          <TooltipHost content={`${name} (${username})`}>
            <Stack horizontal grow verticalAlign="center">
              <ContactIcon className={styles.icon} />
              <Stack.Item className={styles.user}>{name}</Stack.Item>
            </Stack>
          </TooltipHost>
        </Stack>
        <Stack verticalAlign="center">
          <DefaultButton iconProps={{ iconName: `SignOut` }} onClick={() => logout(instance)}>
            {translator.get(`generic.logout`, `Logout`)}
          </DefaultButton>
        </Stack>
      </Stack>
    </Stack>
  );
});
